module.exports = __webpack_public_path__ + "static/pdfWord.pdf";


//////////////////
// WEBPACK FOOTER
// ./static/pdfWord.pdf
// module id = si1o
// module chunks = 128